import { render, staticRenderFns } from "./KYKMView.vue?vue&type=template&id=efa15d54&"
import script from "./KYKMView.vue?vue&type=script&lang=js&"
export * from "./KYKMView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports